import axios from 'axios';
import { ENV_CONFIG } from './environment';
import { clearAllCompanyStorage } from '../utils/companyStorage';

// Configuración de la API
export const API_CONFIG = {
  BASE_URL: ENV_CONFIG.API_BASE_URL,
  TIMEOUT: ENV_CONFIG.API_TIMEOUT,
  
  // Endpoints
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      REGISTER: '/auth/register',
      LOGOUT: '/auth/logout',
      REFRESH: '/auth/refresh',
      ME: '/auth/me'
    },
    USER: '/user'
  }
};

// Claves para localStorage
export const STORAGE_KEYS = {
  JWT_TOKEN: ENV_CONFIG.SANCTUM_TOKEN_KEY, // Mantenemos el nombre por compatibilidad con el código existente
  USER: ENV_CONFIG.USER_KEY,
  ROLES: ENV_CONFIG.ROLES_KEY || 'planillas_user_roles',
  PERMISSIONS: ENV_CONFIG.PERMISSIONS_KEY || 'planillas_user_permissions',
  COMPANY: ENV_CONFIG.COMPANY_KEY
};

// Headers por defecto para API mode
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'X-Requested-With': 'XMLHttpRequest'
};

// Crear instancia de axios
const api = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: DEFAULT_HEADERS
});

// Interceptor para agregar el token Sanctum a las peticiones (modo API)
api.interceptors.request.use(
  (config) => {
    // Agregar headers necesarios para API mode
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    // Dejar que el navegador defina el boundary en uploads multipart
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      if (config.headers && typeof config.headers.set === 'function') {
        config.headers.set('Content-Type', undefined);
      } else if (config.headers) {
        delete config.headers['Content-Type'];
        delete config.headers['content-type'];
      }
    }
    
    const token = localStorage.getItem(STORAGE_KEYS.JWT_TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('🔑 Token Sanctum agregado:', token.substring(0, 20) + '...');
    } else {
      console.log('⚠️ No hay token Sanctum disponible');
    }
    
    console.log('📤 Request headers:', config.headers);
    return config;
  },
  (error) => {
    console.error('❌ Error en request interceptor:', error);
    return Promise.reject(error);
  }
);

// Interceptor para manejar respuestas y errores con Sanctum
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Con Sanctum, si el token expira, simplemente limpiamos y redirigimos
      // No intentamos refresh automático como con JWT
      console.log('🚨 Token Sanctum expirado - redirigiendo al login');
      
      // Limpiar todos los datos de autenticación
      localStorage.removeItem(STORAGE_KEYS.JWT_TOKEN);
      localStorage.removeItem(STORAGE_KEYS.USER);
      localStorage.removeItem(STORAGE_KEYS.ROLES);
      localStorage.removeItem(STORAGE_KEYS.PERMISSIONS);
      clearAllCompanyStorage();
      
      // Redirigir al login si no estamos ya ahí
      if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    
    return Promise.reject(error);
  }
);

// Export por defecto de la instancia de axios configurada
export default api; 